import createSelectors from './createSelectors';
import Document from '../models/Document';

const Select = createSelectors(Document, {});

export default Select;
